<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="notes"><span class="epub-b">NOTES OF GRATITUDE</span></p>
<p class="fmtni">The idea of using a leaden, dispassionate word like “acknowledgments” for this section cannot begin to express the depth of my feelings for the many individuals who have made this book possible. I owe them my deepest and most heartfelt gratitude.</p>
<p class="fmtx">First to my literary manager Peter Miller and my editor Charles Spicer. Without them this book would never have happened. Their support and guidance have been very much appreciated. Also, many, many thanks to Uri, David, and Michelle and the rest of the team at PMA. Also, Peter Wilson, who first brought this case to my attention and whose investigative skills have proved so invaluable in helping me put this book together.</p>
<p class="fmtx">In San Diego and San Francisco numerous friends and associates of Andrew Cunanan helped enormously despite fears for their own safety. Many of them asked that their names be kept confidential. I have respected their wishes and therefore cannot thank them by name.</p>
<p class="fmtx">Then there is my worldwide network of Brendan Bourne, Anthony Bowman and Mark Sandelson in California, John Glatt in New York, Jack Green in Minneapolis, Tony Benwell in Chicago. Also the FBI and police departments of all the cities mentioned in this book. And John Taylor in London.</p>
<p class="fmtx">But one of my biggest debts of gratitude goes to the many friends and colleagues who kept me constantly updated so as to make this book the most up-to-the-minute version of events.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// notes.vue?2e3c733b